import * as fromModel from '../../models/';
import { DataService } from '../data.service';
import { ContextService } from '../context.service';
import { RefDataService } from '../ref-data.service';
import { Constant } from '../../../../environments/constants';
import { Utils } from '../../../../utils/utils';
import { ClientsService } from '../../clients.service';


export class ClientDataTransformaion {

    public static removeClient(clientid: string, dataService: DataService, clientService: ClientsService) {               
        if(dataService && dataService.appData && dataService.appData.Plan 
          && dataService.appData.Plan.planClients && dataService.appData.Plan.planClients.length>0){
            const pclient = dataService.appData.Plan.planClients.find(plClient=>plClient.clientid === clientid);
            if(pclient){
                // if(pclient.role === fromModel.CLIENTROLE.Secondary){   
                //     clientService.removeClient(dataService.appData.Plan.id,clientid).subscribe(result=>{                        
                //     }, err=>{                          
                //     });
                // } else {
                //     clientService.removeClient(dataService.appData.Plan.id,clientid).subscribe(result=>{                        
                //     }, err=>{                          
                //     });
                // } 
                
                clientService.removeClient(dataService.appData.Plan.id,clientid).subscribe(result=>{                                            
                    dataService.setPlanInContext(dataService.appData.Plan.id);
                    dataService.dispatchAction(fromModel.DATA_ACTION.RESET, "ClientDataTransformaion-removeClient", null);
                }, err=>{                          
                });
            }
        }
    } 


    public static removePlanClient(clientid: string, dataService: DataService, contextService: ContextService) {               
        if(dataService && dataService.appData && dataService.appData.Plan 
          && dataService.appData.Plan.planClients && dataService.appData.Plan.planClients.length>0){
            const pclient = dataService.appData.Plan.planClients.find(plClient=>plClient.clientid === clientid);
            if(pclient){
                if(pclient.role === fromModel.CLIENTROLE.Secondary){
                    ClientDataTransformaion.removeAssociatedClients(clientid, dataService, contextService);                                                              
                } 
                ClientDataTransformaion.removeClientRelatedData(clientid, dataService, contextService);                                                              
            }
        }
    } 

    public static removeAssociatedClients(clientid: string, dataService: DataService, contextService: ContextService){
        //let associatedClients = [];
        if(dataService.appData.Clients && dataService.appData.Clients.value && dataService.appData.Clients.value.length>0){
            //Step 1: find household id for given clientid from Client cache object(mostly secondary client) 
            const client = dataService.appData.Clients.value.find(cl=>cl.LegalEntityID === clientid);              
            if(client && client.householdId){                
                
                if(dataService.appData.Households && dataService.appData.Households.value && dataService.appData.Households.value.length>0){
                    //Step 2: find household for given client.householdId from Households cache object
                    const household = dataService.appData.Households.value.find(hh=>hh.householdId === client.householdId);
                    if(household && household.Parties && household.Parties.length>0){
                        let clientAssociatedWithPrimary = [];
                        //Step 3: loop through Households cache object to find out list of partties
                        dataService.appData.Households.value.forEach(hh => {
                            if(hh.householdId!== household.householdId && hh.Parties && hh.Parties.length>0){
                                //Step 4: loop through household.Parties (assocaited client for given client) for  given client
                                
                                hh.Parties.forEach(hhCl => {
                                    const householdCl = household.Parties.find(householdCl=>householdCl.LegalEntityId === hhCl.LegalEntityId);
                                    if(householdCl){
                                        clientAssociatedWithPrimary.push(hhCl);
                                    }
                                });                                  
                                // household.Parties.forEach(householdCl => {
                                //     const hhCl = hh.Parties.find(_hhcl=>_hhcl.LegalEntityId === householdCl.LegalEntityId);
                                //     if(hhCl){
                                //         isClientAssociatedWithPrimary = true;
                                //     }
                                // });                                    
                            }                    
                        });

                        household.Parties.forEach(householdCl => {
                            const hhCl = clientAssociatedWithPrimary.find(_hhcl=>_hhcl.LegalEntityId === householdCl.LegalEntityId);
                            if(!hhCl){
                                ClientDataTransformaion.removeClientRelatedData(householdCl.LegalEntityId, dataService, contextService);
                            }
                        }); 
                    }
                }
            }
        }
    }

    public static removeClientRelatedData(clientid: string, dataService: DataService, contextService: ContextService) {   
        ClientDataTransformaion.removeClientIncome(clientid, dataService);
        ClientDataTransformaion.removeClientInternalAccounts(clientid, dataService, contextService);                
        ClientDataTransformaion.removeClientHypoExternalAccounts(clientid, dataService, contextService);     
        //ClientDataTransformaion.removeClientExpenses(clientid, dataService);
        const pclient = dataService.appData.Plan.planClients.find(plClient=>plClient.clientid === clientid);
        if(pclient){
            const elePos = dataService.appData.Plan.planClients.indexOf(pclient);
            dataService.appData.Plan.planClients.splice(elePos,1); 
            //ClientDataTransformaion.removeClientFromAppData(clientid, dataService);
            //ClientDataTransformaion.removeClientFromAppContext(clientid, contextService);
            

        }
    }

    public static removeClientIncome(clientid: string, dataService: DataService){
        if(dataService.appData.Plan.incomes && dataService.appData.Plan.incomes.length>0){
            const incomes = dataService.appData.Plan.incomes.filter(({owner}) => owner === clientid);
            if(incomes && incomes.length>0){
                incomes.forEach(inc => {
                    const elePos = dataService.appData.Plan.incomes.indexOf(inc);
                    dataService.appData.Plan.incomes.splice(elePos,1);                        
                });                
            }
        }        
    }

    public static removeClientInternalAccounts(clientid: string, dataService: DataService, contextService: ContextService){
        let accountIds = [];
        if(dataService.appData.Plan.planAccounts && dataService.appData.Plan.planAccounts.length>0 
           && dataService.appData.Clients && dataService.appData.Clients.value && dataService.appData.Clients.value.length>0){
            const client = dataService.appData.Clients.value.find(cl=>cl.LegalEntityID === clientid);              
            if(client){
                if(client.Account){
                    accountIds = client.Account;
                }
                if(client.externalAccounts){
                    client.externalAccounts.forEach(exAcc => {
                        accountIds.push(exAcc.accountId);
                    });                      
                }               
                ClientDataTransformaion.removePlanAccounts(accountIds,dataService,contextService);
            }
        }             
    }

    public static removeClientHypoExternalAccounts(clientid: string, dataService: DataService, contextService: ContextService){
        let accountIds = [];
        if(dataService.appData.Plan.planAccounts && dataService.appData.Plan.planAccounts.length>0 
           && dataService.appData.ExternalAccounts && dataService.appData.ExternalAccounts.accounts 
           && dataService.appData.ExternalAccounts.accounts.length>0){
            dataService.appData.ExternalAccounts.accounts.forEach(exAcc => {
                if(exAcc.clientid === clientid){
                    accountIds.push(exAcc.id);
                }
            });
            ClientDataTransformaion.removePlanAccounts(accountIds,dataService, contextService);
        }
    }

    public static removePlanAccounts(accountIds: string[], dataService: DataService, contextService: ContextService){
        if(accountIds && accountIds.length>0){
            accountIds.forEach(accId => {
                const plAcc = dataService.appData.Plan.planAccounts.find(acc=>acc.actNo===accId);
                if(plAcc){
                    const elePos = dataService.appData.Plan.planAccounts.indexOf(plAcc);
                    dataService.appData.Plan.planAccounts.splice(elePos,1);                        
                }
            });
            ClientDataTransformaion.removeClientSavings(accountIds,dataService); 
            //ClientDataTransformaion.removeAccFromAppData(accountIds,dataService); 
            //ClientDataTransformaion.removeAccFromAppContext(accountIds,contextService); 
            
        }
    }

    public static removeClientSavings(accountIds: string[], dataService: DataService){
        if(dataService.appData.Plan.savings && dataService.appData.Plan.savings.length>0 && accountIds && accountIds.length>0){
            accountIds.forEach(accId => {
                const savings = dataService.appData.Plan.savings.filter(({actId}) => actId === accId);
                if(savings && savings.length>0){
                    savings.forEach(sav => {
                        const elePos = dataService.appData.Plan.savings.indexOf(sav);
                        dataService.appData.Plan.savings.splice(elePos,1);                        
                    });                
                }
            });
        }
    }

    // public static removeClientExpenses(clientid: string, dataService: DataService, contextService: ContextService){
    //     if(dataService.appData.Plan.expenses && dataService.appData.Plan.expenses.length>0){
    //         const expenses = dataService.appData.Plan.expenses.filter(({owner}) => owner === clientid);
    //         let expenseIds: string[] = [];
    //         if(expenses && expenses.length>0){
    //             expenses.forEach(exp => {
    //                 const elePos = dataService.appData.Plan.expenses.indexOf(exp);
    //                 dataService.appData.Plan.expenses.splice(elePos,1);                        
    //                 expenseIds.push(exp.expId);
    //             }); 
    //             ClientDataTransformaion.removeClientExpensesFromGoals(expenseIds, dataService, contextService);           
    //         }
    //     }
    // }

    // public static removeClientExpensesFromGoals(expenseIds: string[], dataService: DataService, contextService: ContextService){
    //     if(dataService.appData.Plan.goals && dataService.appData.Plan.goals.length>0){
    //         dataService.appData.Plan.goals.forEach(goal => {
    //             if(goal && goal.expenses && goal.expenses.length>0){
    //                expenseIds.forEach(expId => {
    //                    const _expId = goal.expenses.find(id=>id===expId);
    //                     if(_expId){                            
    //                         const elePos = goal.expenses.indexOf(_expId);
    //                         goal.expenses.splice(elePos,1);  
    //                     }      
    //                });                   
    //             }                   
    //         });
    //     }
    // }

    // public static removeClientGoals(clientid: string, dataService: DataService, contextService: ContextService){
    // }


    /* Start: App Data Related Functions*/
    public static removeClientFromAppData(clientid: string, dataService: DataService){
        if(dataService.appData.Clients && dataService.appData.Clients.value && dataService.appData.Clients.value.length>0){
            const client = dataService.appData.Clients.value.find(cl=>cl.LegalEntityID === clientid);
            if(client){
                const elePos = dataService.appData.Clients.value.indexOf(client);
                dataService.appData.Clients.value.splice(elePos,1); 
            }
        }
    }

    public static removeAccFromAppData(accountIds: string[], dataService: DataService){
        if(dataService.appData.Accounts && dataService.appData.Accounts.value && dataService.appData.Accounts.value.length>0){
            if(accountIds && accountIds.length>0){
                accountIds.forEach(accId => {
                    const account = dataService.appData.Accounts.value.find(acc=>acc.id===accId);
                    if(account){
                        const elePos = dataService.appData.Accounts.value.indexOf(account);
                        dataService.appData.Accounts.value.splice(elePos,1);                        
                    }
                });
            }
        }

        if(dataService.appData.ExternalAccounts && dataService.appData.ExternalAccounts.accounts && dataService.appData.ExternalAccounts.accounts.length>0){
            if(accountIds && accountIds.length>0){
                accountIds.forEach(accId => {
                    const hypoExtAccount = dataService.appData.ExternalAccounts.accounts.find(acc=>acc.id===accId);
                    if(hypoExtAccount){
                        const elePos = dataService.appData.ExternalAccounts.accounts.indexOf(hypoExtAccount);
                        dataService.appData.ExternalAccounts.accounts.splice(elePos,1);                        
                    }
                });
            }
        }

    }
    /* End: App Data Related Functions*/

    /* Start: App Context Related Functions*/
    public static removeClientFromAppContext(clientid: string, contextService: ContextService){
        if(contextService.context.Clients && contextService.context.Clients.length>0){
            const client = contextService.context.Clients.find(cl=>cl.clientid === clientid);
            if(client){
                const elePos = contextService.context.Clients.indexOf(client);
                contextService.context.Clients.splice(elePos,1); 
            }
        }
    }

    public static removeAccFromAppContext(accountIds: string[], contextService: ContextService){
        if(accountIds && accountIds.length>0){
            if(contextService.context.Account && contextService.context.Account.length>0){            
                accountIds.forEach(accId => {
                    const account = contextService.context.Account.find(id=>id===accId);
                    if(account){
                        const elePos = contextService.context.Account.indexOf(account);
                        contextService.context.Account.splice(elePos,1);                        
                    }
                });
            }

            if(contextService.context.SelectedAccounts && contextService.context.SelectedAccounts.length>0){            
                accountIds.forEach(accId => {
                    const selectedAccount = contextService.context.SelectedAccounts.find(id=>id===accId);
                    if(selectedAccount){
                        const elePos = contextService.context.SelectedAccounts.indexOf(selectedAccount);
                        contextService.context.SelectedAccounts.splice(elePos,1);                        
                    }
                });
            }

            if(contextService.context.SelectedExternalAccounts && contextService.context.SelectedExternalAccounts.length>0){            
                accountIds.forEach(accId => {
                    const selectedHypoExtAccount = contextService.context.SelectedExternalAccounts.find(id=>id===accId);
                    if(selectedHypoExtAccount){
                        const elePos = contextService.context.SelectedExternalAccounts.indexOf(selectedHypoExtAccount);
                        contextService.context.SelectedExternalAccounts.splice(elePos,1);                        
                    }
                });
            }
        }       

    }
    /* End: App Context Related Functions*/
   
}